export const taskCenter = {
    syrw: '임무로 시작하여, 당신으로 마무리됩니다',
    zjlbt: '코인왕 USDT 증정 혜택 지속 받기',
    wdjj: '내 보너스',
    rwsm: '임무 설명',
    rwlb: '임무 목록',
    jljl: '보상 기록',
    klq: '수령 가능',
    flzm: '코인왕 혜택 문',
    dcjl: '달성시 즉시 수령 USDT 보너스가 당신을 항상 동반합니다',
    yjlq: '일괄 수령',
    lqcg: '수령 성공',
    wdl: '로그인되지 않음',
    jxz: '진행 중',
    ylq: '이미 수령됨',
    rwjd: '임무 진행',
    xsrw: '신입자 임무',
    hyrw: '계약 임무',
    cjrz: '초급 인증',
    gjrz: '고급 인증',
    scbbjy: '최초 코인-코인 거래',
    schyjy: '최초 계약 거래',
    sccz: '최초 입금',
    schyhz: '최초 계약 이체',
    jyl: '거래 금액',
    ylje: '수익 금액',
    ksje: '손실 금액',
    dbkcbzj: '단일 포지션 보증금',
    rjl: '입금 금액',
    dbczje: '단일 충전 금액',
    rwxq: '임무 세부 정보'
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/task/kr.js